(() => {
  'use strict';
  // Home only (Josh 10/17): Yuliia's two NE leaves blow down through the sky from the top of the band to the trust
  // row. A gust comes every 25-45 s (first one a few seconds in). v2 (Josh: "a few more at varying sizes and angles /
  // reflection… increase the rarity and anomaly of how they blow around"): 2-4 leaves a gust, now and then a flurry
  // of 5-7 or a whirl where they all loop at once; each leaf has its own size (small = far = slower), angle, mirror
  // side and flip, catches the light as it turns, and may get an odd move: a loop-the-loop, an updraft, a sideways
  // whip or a hanging stall. They pass in front of the stickers but behind the copy, never take clicks, and only fly
  // while the header's motion is on and on screen (paused, reduced motion or scrolled away = no leaves).
  // v3 (Josh: "i just want leaves to fall like right away on open so everyone sees it… like a 1 sec delay"): the
  // opening gust is a plain breeze of 2-3 leaves 1 s after load (retrying every half second until the header is live).
  // Remove: delete this file's <script> in home.html (and the .home-leaves rules in home-collage.css).
  const intro = document.querySelector('.home-page .home-intro');
  if (!intro) return;
  const LEAVES = [(window.VP_CDN+"vp-stickers__leaf-1.webp?v=c5911f3d1a"), (window.VP_CDN+"vp-stickers__leaf-2.webp?v=95561672c9")];
  const ASPECT = [226 / 240, 235 / 240];
  const FIRST = [1000, 1000], EVERY = [25000, 45000];
  // Fetch the art now so the opening leaves aren't still loading when they launch.
  LEAVES.forEach(src => { new Image().src = src; });
  const layer = document.createElement('div');
  layer.className = 'home-leaves';
  layer.setAttribute('aria-hidden', 'true');
  intro.prepend(layer);
  const phone = matchMedia('(max-width: 720px)');
  const rand = (a, b) => a + Math.random() * (b - a);
  const side = () => Math.random() < .5 ? -1 : 1;
  // 0 -> 1 -> 0 over [t0, t0 + d], smooth at both ends.
  const bump = (t, t0, d) => t <= t0 || t >= t0 + d ? 0 : Math.sin(Math.PI * (t - t0) / d) ** 2;
  const flying = [];
  let frame = 0, last = 0, timer = 0, opened = false;

  const header = () => document.getElementById('library-header');
  const live = () => {
    const h = header();
    return !!h && h.dataset.motion === 'on' && h.dataset.visible === 'true' && !document.hidden;
  };
  // Leaf size follows the sticker unit, so leaves stay small next to the stickers at every window size.
  const unit = () => parseFloat(header()?.style.getPropertyValue('--u')) || 12;
  // Floor = the top of the trust row (or the intro's bottom), so leaves never land on the badges.
  const floor = () => {
    const trust = intro.querySelector('.hero-trust');
    const top = intro.getBoundingClientRect().top;
    return trust && trust.getClientRects().length ? trust.getBoundingClientRect().top - top : intro.offsetHeight;
  };

  function schedule(range) {
    clearTimeout(timer);
    timer = setTimeout(gust, rand(...range));
  }

  // kind: 'breeze' (2-4 leaves, most gusts), 'flurry' (5-7, about 1 in 8) or 'whirl' (2-4 that loop together, 1 in 10).
  // The opening gust is always a breeze of 2-3.
  function gust(kind) {
    if (!kind && !live()) { schedule(opened ? [4000, 8000] : [500, 500]); return; }
    const first = !opened;
    opened = true;
    const roll = Math.random();
    kind = kind || (first ? 'breeze' : roll < .1 ? 'whirl' : roll < .22 ? 'flurry' : 'breeze');
    const W = intro.clientWidth, H = floor(), u = unit();
    const wind = side() * rand(.03, kind === 'breeze' ? .07 : .085) * W;
    const count = kind === 'flurry' ? 5 + Math.floor(rand(0, 3)) : 2 + Math.floor(rand(0, first ? 2 : 3));
    // Leaves start upwind so the gust carries them across, not straight off the side.
    const origin = wind > 0 ? rand(.05, .6) * W : rand(.4, .95) * W;
    const whirlAt = rand(2.4, 3.6);
    let delay = 0;
    for (let i = 0; i < count; i++) {
      const at = delay;
      setTimeout(() => launch(W, H, u, wind, origin + rand(-.22, .22) * W, kind === 'whirl' ? Math.max(.8, whirlAt - at / 1000) : 0), at);
      delay += kind === 'flurry' ? rand(150, 700) : rand(400, 1500);
    }
    schedule(EVERY);
  }

  function launch(W, H, u, wind, x0, whirl) {
    if (!live()) return;
    const art = Math.random() < .5 ? 0 : 1;
    // Depth 0 = far (small, slow, a touch faded) .. 1 = near (bigger, quicker); most leaves are small.
    const depth = Math.random() ** 1.5;
    const [lo, hi] = phone.matches ? [2.8, 5.4] : [1.1, 2.8];
    const size = u * (lo + (hi - lo) * depth);
    const img = new Image();
    img.src = LEAVES[art];
    img.alt = '';
    img.decoding = 'async';
    img.draggable = false;
    img.style.width = size.toFixed(1) + 'px';
    img.style.height = (size * ASPECT[art]).toFixed(1) + 'px';
    layer.append(img);
    const speed = (phone.matches ? 55 : 62) * (.75 + .6 * depth) * rand(.9, 1.15);
    const fallTime = (H + 2 * size) / speed;
    const reach = (phone.matches ? .6 : 1) * (.7 + .6 * depth);
    // The odd moves: a whirl gust gives every leaf the same loop; otherwise about half the leaves get one or two.
    const events = [];
    const add = (type, t0) => {
      if (type === 'loop') events.push({ type, t0, d: rand(1.5, 2.3), r: rand(18, 38) * reach, dir: side() });
      if (type === 'updraft') events.push({ type, t0, d: rand(1.4, 2.4), lift: rand(1.8, 2.6) });
      if (type === 'whip') events.push({ type, t0, d: rand(.8, 1.4), push: side() * rand(.18, .32) * W });
      if (type === 'stall') events.push({ type, t0, d: rand(1.5, 2.5), spin: side() * rand(160, 280) });
    };
    if (whirl) add('loop', whirl);
    else {
      const n = Math.random() < .45 ? 0 : Math.random() < .75 ? 1 : 2;
      for (let i = 0; i < n; i++) add(['loop', 'updraft', 'whip', 'stall'][Math.floor(rand(0, 4))], rand(1.2, Math.max(1.6, fallTime * .7)));
    }
    flying.push({ img, size, H, depth, speed, events, t: 0, x: x0, y: -size * 1.5,
      wind: wind * rand(.6, 1.4), sway: rand(.9, 1.8) * size, swingRate: rand(1, 1.8), phase: rand(0, 6.3),
      turbulence: [rand(0, 6.3), rand(0, 6.3)], flipRate: rand(.7, 3.2), mirror: side(),
      turn: rand(0, 360), spin: rand(-40, 40), alpha: .78 + .22 * depth });
    if (!frame) { last = 0; frame = requestAnimationFrame(step); }
  }

  // Pendulum flutter: the leaf swings side to side, rises a touch at the end of each swing and tilts with it, while a
  // wind that rises and falls carries it sideways. It flips over (scaleX through 0 = its mirror side) and brightens
  // for a moment when its face turns to the light. The odd moves add on top.
  function step(now) {
    frame = 0;
    const dt = last ? Math.min(.05, (now - last) / 1000) : 0;
    last = now;
    const on = live(), W = intro.clientWidth;
    for (let i = flying.length - 1; i >= 0; i--) {
      const leaf = flying[i];
      const t = leaf.t += dt;
      let fall = 1, push = 0, ox = 0, oy = 0, spin = 0;
      for (const e of leaf.events) {
        const b = bump(t, e.t0, e.d);
        if (e.type === 'updraft') fall -= e.lift * b;
        if (e.type === 'whip') push += e.push * b;
        if (e.type === 'stall') { fall *= 1 - .9 * b; spin += e.spin * b * dt; }
        if (e.type === 'loop' && t > e.t0) {
          const v = Math.min(1, (t - e.t0) / e.d), a = 2 * Math.PI * v * v * (3 - 2 * v);
          ox += e.dir * e.r * Math.sin(a);
          oy -= e.r * (1 - Math.cos(a));
          fall *= 1 - b;
          if (v < 1) spin += e.dir * 360 / e.d * Math.sin(Math.PI * v) * dt;
        }
      }
      const [g1, g2] = leaf.turbulence;
      leaf.x += (leaf.wind * (.65 + .3 * Math.sin(t * .8 + g1) + .2 * Math.sin(t * 2.3 + g2)) + push) * dt;
      leaf.y += leaf.speed * fall * dt;
      leaf.turn += (leaf.spin * dt) + spin;
      const swing = leaf.swingRate * t + leaf.phase;
      const x = leaf.x + leaf.sway * Math.sin(swing) + ox;
      const y = leaf.y + .35 * leaf.size * Math.cos(2 * swing) + oy;
      const flip = leaf.flipRate * t + leaf.phase;
      const glint = 1 + .4 * Math.max(0, Math.cos(flip - .6)) ** 14;
      const fade = Math.min(1, t / .6, (leaf.H - y) / (leaf.H * .14));
      const gone = y > leaf.H || x < -3 * leaf.size || x > W + 3 * leaf.size || t > 45;
      if (gone || !on) { leaf.img.remove(); flying.splice(i, 1); continue; }
      leaf.img.style.opacity = Math.max(0, fade * leaf.alpha).toFixed(3);
      leaf.img.style.filter = `drop-shadow(0 1px 2px #00000024) brightness(${glint.toFixed(3)})`;
      leaf.img.style.transform = `translate3d(${(x - leaf.size / 2).toFixed(1)}px,${y.toFixed(1)}px,0) ` +
        `rotate(${(leaf.turn + 28 * Math.cos(swing)).toFixed(1)}deg) ` +
        `scale(${(leaf.mirror * Math.cos(flip)).toFixed(3)},${(.88 + .12 * Math.cos(flip * .6)).toFixed(3)})`;
    }
    if (flying.length) frame = requestAnimationFrame(step);
  }

  // Test hook: VPHomeLeaves.gust() sends one now; gust('whirl') / gust('flurry') / gust('breeze') picks the kind.
  window.VPHomeLeaves = { gust };
  schedule(FIRST);
})();
